import React, { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/PageLayout.css';

interface PageLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

/**
 * Standard layout component for content pages
 */
const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  title,
  subtitle,
  backgroundImage 
}) => {
  const navigate = useNavigate();
  
  return (
    <div className="page-layout">
      <header className="page-header">
        <div className="header-content">
          <Link to="/" className="logo-container">
            <img 
              src="/images/golfscape-logo.png" 
              alt="GolfScape Tee Off Logo" 
              style={{ 
                maxWidth: '280px', 
                height: 'auto',
                display: 'block',
                margin: '0 auto'
              }} 
            />
          </Link>
          
          <nav className="main-nav">
            <button onClick={() => navigate('/')}>
              Book Tee Time
            </button>
          </nav>
        </div>
      </header>
      
      <div 
        className="page-banner" 
        style={backgroundImage ? { 
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})` 
        } : undefined}
      >
        <div className="banner-content">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      
      <main className="page-content">
        <div className="content-container">
          {children}
        </div>
      </main>
      
      <footer className="page-footer">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">
              <img 
                src="/images/golfscape-logo.png" 
                alt="GolfScape Tee Off Logo" 
                style={{ 
                  maxWidth: '200px', 
                  height: 'auto',
                  display: 'block',
                  margin: '0 0 10px 0'
                }} 
              />
              <p>Making golf accessible since 2023</p>
            </Link>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h3>Company</h3>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/partners">Partners</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3>Resources</h3>
              <ul>
                <li><Link to="/golf-tips">Golf Tips</Link></li>
                <li><Link to="/course-reviews">Course Reviews</Link></li>
                <li><Link to="/equipment-guide">Equipment Guide</Link></li>
              </ul>
            </div>
            
            <div className="footer-column">
              <h3>Support</h3>
              <ul>
                <li><Link to="/help">Help Center</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} GolfScape. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PageLayout;
